
import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

@Component
export default class SwitchToggle extends Vue {
  @Model('change', { type: Boolean, default: false }) isOn!: boolean;

  @Prop({ default: 'Encendido' }) onText!: string;
  @Prop({ default: 'Apagado' }) offText!: string;

  @Watch('isOn')
  onIsOnChanged(newValue: boolean) {
    this.$emit('change', newValue);
  }
}
